import { first, forEach, includes, isArray, isEmpty, isObject, isBoolean } from 'lodash';

import { UrlService, WindowProxy } from '@sm360/widget-commons-core-services';
import { getFilters } from 'inventory-listing/services/ListingUsedService/ListingUsedService.js';

class UrlManagement {
    changeUrl(listingUsed) {
        const windowProxy = WindowProxy.get();

        if (!listingUsed || !windowProxy) {
            return;
        }

        const queryParams = this.createQueryParams(listingUsed);
        const url = this.buildUrl(listingUsed);
        if (url) {
            windowProxy.history.replaceState(
                {
                    filter: 'filter',
                },
                'filter',
                `${url}${queryParams}`
            );
        }
    }

    createQueryParams(listingUsed) {
        let queryParamsString = '';
        const queryParams = UrlService.getUrlParameters();

        if (!listingUsed) {
            return queryParamsString;
        }

        listingUsed.vehicleCriteria.forEach((value, key) => {
            if (
                !includes(key, 'colander') &&
                !includes(key, 'make') &&
                !includes(key, 'model') &&
                !includes(key, 'category') &&
                !includes(key, 'vehicleStatuses')
            ) {
                if (isArray(value)) {
                    queryParams[key] = value.join(',');
                } else if (isObject(value) && !isEmpty(value)) {
                    const formattedKey = key.split('Range')[0];
                    queryParams[`${formattedKey}From`] = value.from;
                    queryParams[`${formattedKey}To`] = value.to;
                } else if (!isObject(value) && !isBoolean(value)) {
                    queryParams[key] = value;
                }
            }
        });
        forEach(queryParams, (paramValue, paramName) => {
            const paramSign = !queryParamsString ? '?' : '&';
            if (paramValue) {
                queryParamsString += `${paramSign}${paramName}=${paramValue}`;
            }
        });

        return queryParamsString;
    }

    buildUrl(listingUsed) {
        if (!listingUsed) {
            return null;
        }

        const { vehicleCriteria } = listingUsed;
        const filters = listingUsed.metadatas;
        let url = listingUsed.contextUrl;
        const { colanderSlug } = vehicleCriteria;

        const makeId = first(vehicleCriteria.makeIds);
        const modelId = first(vehicleCriteria.modelIds);

        if (colanderSlug) {
            const selectedColanderUrl = listingUsed.colanders.find((colander) => colander.slug === colanderSlug)
                .urlMapping;
            url = UrlService.replaceParamWithValue(url, '{hubCategory}', selectedColanderUrl);
        } else {
            url = UrlService.replaceParamWithValue(url, '{hubCategory}', 'used');
        }

        if (makeId) {
            const makes = getFilters(filters, 'MAKE');
            const selectedMakeUrl = makes.find((make) => {
                return make.code === makeId;
            }).url;
            url = UrlService.replaceParamWithValue(url, '{make}', selectedMakeUrl);
        } else {
            url = UrlService.replaceParamWithValue(url, '/{make}', '');
        }

        if (modelId) {
            const models = getFilters(filters, 'MODEL');
            const selectedMakeUrl = models.find((model) => {
                return model.code === modelId;
            }).url;
            url = UrlService.replaceParamWithValue(url, '{model}', selectedMakeUrl);
        } else {
            url = UrlService.replaceParamWithValue(url, '/{model}', '');
        }

        return UrlService.replaceParamWithValue(url, '/{year}', '');
    }
}

export default new UrlManagement();



// WEBPACK FOOTER //
// ./client/src/services/UrlManagement/UrlManagement.js